import React, { useState } from "react";
import PropTypes from "prop-types";
import BugReport from "./BugReport";
import Button from "@mui/material/Button";
import HelpDeskReport from "./HelpDeskResport";
import { useAuth0 } from "@auth0/auth0-react";
import Box from "@mui/material/Box";

// Styles.
import {ReportButtonsStyles as styles} from "./ReportButtons.styles";

/**
 * Buttons linked to Ybug to generate reports.
 * @param {string} boardType - The type of the board page.
 * @param {object} collectedData - The collected data to create a report.
 * @param {string} userType - A default value for user when Auth0 is not defined.
 * @returns {JSX.Element}
 */
const ReportButtons = ({ boardType, collectedData, userType = 'anonymous' }) => {
  const [bugReport, setBugReport] = useState(false);
  const [helpDeskReport, setHelpDeskReport] = useState(false);

  const { user } = useAuth0();
  let userRole = user ? user[`${process.env.REACT_APP_AUTH0_KEY}/role`] : userType;

  return (
    <Box className="ReportButtons" sx={styles}>
      <div className="ReportButtons__wrapper">
        <Button variant="contained" className="ReportButtons__item bugReport" onClick={() => {
          setBugReport(true);
          setHelpDeskReport(false);
        }}>Bug Report</Button>

        {
          userRole === 'api_group_admin' &&
          <Button variant="contained" className="ReportButtons__item helpDeskButton" onClick={() => {
            setHelpDeskReport(true);
            setBugReport(false);
          }}>Help Desk</Button>

        }
      </div>
      {
        bugReport && <BugReport type={boardType} reportData={collectedData} onClose={() => {
          // Both hooks need to be updated because ybug on close function.
          setBugReport(false);
          setHelpDeskReport(false);
        }} />
      }
      {
        helpDeskReport && <HelpDeskReport type={boardType} onClose={() => {
          // Both hooks need to be updated because ybug on close function.
          setBugReport(false);
          setHelpDeskReport(false);
        }} />
      }
    </Box>
  )
}

ReportButtons.propTypes = {
  boardType: PropTypes.string.isRequired,
  collectedData: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  userType: PropTypes.string,
}

export default React.memo(ReportButtons);
